import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { deepMix } from '@antv/util';
import { rollups, sum } from 'd3-array';
import { columnOf } from './utils/helper';
function valueOf(data, field) {
  if (typeof field === 'string') return data.map(function (d) {
    return d[field];
  });
  return data.map(field);
}
function createReducer(reducer, V) {
  if (typeof reducer === 'function') return function (GI) {
    return reducer(GI, V);
  };
  if (reducer === 'sum') return function (GI) {
    return sum(GI, function (i) {
      return +V[i];
    });
  };
  throw new Error("Unknown reducer: ".concat(reducer));
}
/**
 * Produce flex options from data for x scale.
 */
export var FlexX = function FlexX() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var field = options.field,
    _options$channel = options.channel,
    channel = _options$channel === void 0 ? 'y' : _options$channel,
    _options$reducer = options.reducer,
    reducer = _options$reducer === void 0 ? 'sum' : _options$reducer;
  return function (I, mark) {
    var data = mark.data,
      encode = mark.encode;
    var _columnOf = columnOf(encode, 'x'),
      _columnOf2 = _slicedToArray(_columnOf, 1),
      x = _columnOf2[0];
    var V = field ? valueOf(data, field) : columnOf(encode, channel)[0];
    var reducerFunction = createReducer(reducer, V);
    var flex = rollups(I, reducerFunction, function (i) {
      return x[i];
    }).map(function (d) {
      return d[1];
    });
    return [I, deepMix({}, mark, {
      scale: {
        x: {
          flex: flex
        }
      }
    })];
  };
};
FlexX.props = {};